import axios from "axios";
import Cookies from "js-cookie";
import {ID_TOKEN, TOKEN_STRING} from "../../conf";
import {getBooleanByParameter} from "../../utils/textOptions";

const tokenFromCookie = Cookies.get(ID_TOKEN);

const instance = axios.create({
    baseURL: getBooleanByParameter(process.env.REACT_APP_PRODUCTION) ?
        process.env.REACT_APP_REACT_API_BACKEND : '',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

if (tokenFromCookie) {
    instance.defaults.headers.common.Authorization = TOKEN_STRING + tokenFromCookie;
}

export const updateToken = (token: string) => {
    instance.defaults.headers.common.Authorization = TOKEN_STRING + token;
};

export default instance;
